import { useEffect, useState } from "react";
import Dropzone from "react-dropzone";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Snackbar,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import CustomButton from "../../../ui/button/Button";
import { subirExcelTrabajos } from "../../../components/functions/Projects";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const ModalSubirExcelTrabajos = ({ API_URL, open, onClose, setShowLoader }) => {
  const [file, setFile] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  useEffect(() => {
    if (open) {
      setFile(null);
      setTableData([]);
    }
  }, [open]);

  useEffect(() => {
    const handleFileUpload = async () => {
      try {
        setShowLoader(true);
        const res = await subirExcelTrabajos(API_URL, file);
        setTableData(res[0].respuestaGenerales);
        setShowLoader(false);
      } catch (error) {
        setShowLoader(false);
        setShowSnackbar(true);
        setSnackbarMessage("Ocurrió un error al subir el archivo");
      }
    };
    if (file) {
      handleFileUpload();
    }
  }, [file]);

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog fullWidth maxWidth="md" open={open} onClose={handleClose}>
      <Snackbar
        open={showSnackbar}
        autoHideDuration={3000}
        onClose={() => {
          setShowSnackbar(false);
          setSnackbarMessage("");
        }}
        message={snackbarMessage}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        slotProps={{
          content: {
            sx: {
              backgroundColor: "white",
              color: "#222",
              justifyContent: "center",
              textAlign: "center",
              fontWeight: "bold",
              fontSize: "16px",
              fontFamily: "Roboto, Arial, sans-serif",
            },
          },
        }}
      />
      <DialogTitle>Subir Excel Centros de Carga</DialogTitle>
      <DialogContent>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "12px",
          }}
        >
          <Dropzone
            accept={{ "application/vnd.ms-excel": [] }}
            multiple={false}
            onDrop={(acceptedFiles) => {
              const file = acceptedFiles?.[0];
              if (file) {
                setFile(file);
              }
            }}
          >
            {({ getRootProps, getInputProps, isDragActive }) => (
              <section
                className="editor-drop-area"
                style={{
                  backgroundColor: isDragActive ? "#eef7ff" : "#f9f9f9",
                }}
              >
                <div {...getRootProps()} style={{ padding: "40px" }}>
                  <input {...getInputProps()} />
                  <p>{"Seleccionar o arrastrar archivo .xls"}</p>
                </div>
              </section>
            )}
          </Dropzone>
          {tableData.length > 0 && (
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontFamily: "Nunito" }} align="center">
                      Estatus
                    </TableCell>
                    <TableCell sx={{ fontFamily: "Nunito" }} align="left">
                      Descripción
                    </TableCell>
                    <TableCell sx={{ fontFamily: "Nunito" }} align="left">
                      Mensaje
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tableData.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell sx={{ fontFamily: "Nunito" }} align="center">
                        {row?.exitoso ? (
                          <CheckCircleOutlineIcon color="success" />
                        ) : (
                          <ErrorOutlineIcon color="error" />
                        )}
                      </TableCell>
                      <TableCell sx={{ fontFamily: "Nunito" }} align="left">
                        {row?.descripcion}
                      </TableCell>
                      <TableCell sx={{ fontFamily: "Nunito" }} align="left">
                        {row?.mensaje}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </div>
      </DialogContent>
      <DialogActions>
        <CustomButton
          background={"#FFFFFF"}
          color={"#223D51"}
          text="Cerrar"
          height="40px"
          fontWeight="700"
          fontSize="14px"
          border="1px solid #D9D9D9"
          type="button"
          width={"100px"}
          onClick={handleClose}
        />
      </DialogActions>
    </Dialog>
  );
};

export default ModalSubirExcelTrabajos;
